import script from "./EquipmentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipmentItem.vue?vue&type=script&setup=true&lang=js"

import "./EquipmentItem.vue?vue&type=style&index=0&id=90479cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90479cec"]])

export default __exports__